import { useAppSelector } from "@store";
import { Dialog } from "@/shared";
import { Wrapper } from "./Wrapper";

const DIALOG_ID = "ZIsWK2DJpgNRaTvxRFIPZ";

export const Activation = () => {
  const isActive = useAppSelector(
    (state) => state.global.dialogId === DIALOG_ID,
  );

  if (!isActive) return null;

  return (
    <Dialog
      open={true}
      id={DIALOG_ID}
      className="!tw-overflow-visible !tw-bg-[transparent] !tw-shadow-none"
    >
      <Wrapper />
    </Dialog>
  );
};
